<template>
  <div>
    <button class="points-map__btn btn" @click="modalShow = true">
      Dodaj obserwację
    </button>
    <b-modal
      v-model="modalShow"
      hide-footer
      hide-header
      size="lg"
      body-class="p-0"
    >
      <div class="col-12">
        <b-form class="vform">
          <div class="row">
            <div class="col-lg-12">
              <div
                class="mp__close-modal text-right pt-2"
                @click="modalShow = false"
              >
                <span class="">X</span>
              </div>
            </div>
            <div class="col-lg-12">
              <h2 class="points-map__title text-center pt-4 pb-4">
                Dodaj stanowisko nawłoci
              </h2>
              <p class="naw__text px-lg-5 text-center">
                Zaznacz na mapie miejsce, w którym rośnie nawłoć, uzupełnij swoje
                dane, a my w odpowiednim do tego czasie wyślemy Ci przypomnienie
                mailem lub sms, że to dobry moment na jej usunięcie wraz z
                podpowiedzią, jak to skutecznie zrobić.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <b-form-group>
                <b-form-input
                  id="name"
                  autocomplete="given-name"
                  v-on:click="onClickElement('name')"
                  v-model="form.name"
                  :v="$v.form.name"
                  required
                  placeholder="Imię*"
                  :class="{
                    'is-invalid': $v.form.name.$error,
                  }"
                ></b-form-input>
                <div v-if="$v.form.name.$dirty" class="text-danger-name">
                  <div
                    class="text-danger text-left"
                    v-if="!$v.form.name.required"
                  >
                    <small>Pole wymagane</small>
                  </div>
                  <div
                    class="text-danger text-left"
                    v-if="!$v.form.name.minLength"
                  >
                    <small> Minimalna długość imienia to 3 znaki </small>
                  </div>
                  <div
                    class="text-danger text-left"
                    v-if="!$v.form.name.maxLength"
                  >
                    <small>
                      Zbyt długie imię. Maksymalna długość to 255 znaków</small
                    >
                  </div>
                </div>
              </b-form-group>
            </div>

            <div class="col-lg-6">
              <b-form-group>
                <b-form-input
                  id="email"
                  :v="$v.form.email"
                  v-model="form.email"
                  v-on:click="onClickElement('email')"
                  type="email"
                  required
                  placeholder="Email*"
                  :class="{
                    'is-invalid': $v.form.email.$error,
                  }"
                ></b-form-input>
                <div v-if="$v.form.email.$dirty">
                  <div
                    class="text-danger text-left"
                    v-if="!$v.form.email.required"
                  >
                    <small>Pole wymagane</small>
                  </div>
                  <div
                    class="text-danger text-left"
                    v-if="!$v.form.email.email"
                  >
                    <small>Wpisz poprawny email</small>
                  </div>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-6">
              <small class="text-bee"
                >Jeśli chcesz dostać przypomnienie sms, zostaw swój
                numer:</small
              >
            </div>
            <div class="col-lg-6">
              <b-form-group>
                <b-form-input
                  id="name"
                  autocomplete="phone"
                  v-model="form.phone"
                  v-on:click="onClickElement('name')"
                  v-on:keypress="onEnterPhone"
                  v-on:blur="onBlurPhone"
                  placeholder="Telefon"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-6"></div>
            <div class="col-lg-12">
              <div class="w-100" style="height: 400px; width: 100%">
                <l-map
                  id="mapform"
                  v-if="showMap"
                  style="height: 400px; width: 100%"
                  :zoom="zoom"
                  :center="center"
                  @click="addMarker"
                  @ready="onMapReady"
                >
                  <l-marker v-if="userLocation" :lat-lng="userLocation">
                    <l-popup>Tu jesteś</l-popup>
                    <l-icon
                      iconUrl="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-grey.png"
                      shadowUrl="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png"
                    ></l-icon>
                  </l-marker>
                  <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                  ></l-tile-layer>
                  <l-marker
                    v-for="marker in markers"
                    :key="marker.id"
                    :lat-lng="marker.latLng"
                    :attribution="attribution"
                  >
                    <l-icon
                      iconUrl="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png"
                      shadowUrl="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png"
                    ></l-icon>
                    <l-popup> Nawłoć jest tu: {{ marker.latLng }} </l-popup>
                  </l-marker>
                </l-map>
              </div>

              <input
                id="text"
                type="hidden"
                autocomplete="family-name"
                v-model="form.mappoints"
                required
                class="form-control"
                rows="3"
                :class="{
                  'is-invalid': $v.form.mappoints.$error,
                }"
              />
              <div v-if="$v.form.mappoints.$dirty">
                <div
                  class="text-danger text-left"
                  v-if="!$v.form.mappoints.required"
                >
                  <small
                    ><strong
                      ><br />JESZCZE MUSISZ ZAZNACZYĆ NA MAPIE, GDZIE JEST
                      NAWŁOĆ :)</strong
                    ></small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="p-2">
            <b-form-group id="consents" class="text-left vform__consents mt-2">
              <b-form-checkbox-group
                v-model="form.consents"
                v-on:click="onClickElement('consents')"
                class="form__checkboxes"
                :class="{
                  'is-invalid': $v.form.consents.$error,
                }"
              >
                <b-form-checkbox value="3">
                  <div class="pt-1">
                    Wyrażam zgodę na informowanie mnie mailowo o działaniach
                    Greenpeace związanych z ochroną środowiska, o projektach i o
                    możliwościach ich wsparcia.
                  </div>
                </b-form-checkbox>
              </b-form-checkbox-group>
              <div v-if="$v.form.consents.$dirty">
                <div
                  class="text-danger text-left"
                  v-if="!$v.form.consents.required"
                >
                  <small v-html="content.data.form.agreement_7"></small>
                </div>
              </div>
              <b-form-checkbox
                value="2"
                class="form__checkboxes mt-1"
                v-if="form.phone !== ''"
                v-model="form.consents"
                v-on:click="onClickElement('agreementPhone')"
                ><span
                  >Wyrażam zgodę na kontakt telefoniczny ze strony Greenpeace
                  Polska w sprawie tej i innych kampanii związanych z ochroną
                  przyrody</span
                >
              </b-form-checkbox>

              <div v-if="$v.form.consents.$dirty">
                <div
                  class="text-danger text-left"
                  v-if="!$v.form.consents.mustBe2Length"
                >
                  <small
                    >Jeśli chcesz otrzymac sms z przypomnieniem, wyraź zgodę na
                    kontakt telefoniczny. A jeśli nie - usuń numer
                    telefonu</small
                  >
                </div>
              </div>
            </b-form-group>
            <div class="form__checkboxes pb-1 pb-lg-0">
              <p v-html="content.data.form.additional_field_1"></p>
            </div>
          </div>
          <div class="text-center">
            <div class="form__submit font-bold d-inline-flex" @click="onSubmit">
              <span v-if="!isLoading">Gotowe!</span>
              <div>
                <span v-if="isLoading" class="formloader">
                  <span class="dot"></span>
                  <span class="dot"></span>
                  <span class="dot"></span>
                </span>
              </div>
            </div>
          </div>

          <div class="form__legal-notice pb-5 pb-lg-0">
            <p v-html="content.data.form.legalNotice_6"></p>
          </div>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>
<!-- FOR OPEN PAYU -->
<script></script>

<script>
import axios from "axios";
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "vue2-leaflet";

import {
  email,
  required,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

export default {
  name: "Form",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
  },
  inject: ["content"],

  data() {
    return {
      modalShow: false,
      title: "Formularz",
      showMap: false,
      isLoading: false,
      form: {
        inviteToPay: new URLSearchParams(location.search).get("inviteToPay"),
        inviteToSinglePayment: new URLSearchParams(location.search).get(
          "inviteToSinglePayment"
        ),

        fundraiser: new URLSearchParams(location.search).get("fundraiser"),
        tag: new URLSearchParams(location.search).get("tag"),
        email: "",
        name: "",
        mappoints: "",
        phone: "",
        consents: [],
        contactType: [],
      },
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 6,
      center: [52.303, 20.71],
      markers: [],
      nextMarkerId: 6,
      userLocation: null, // To store the user's location if you want to mark it
      map: null, // Placeholder for the map object
    };
  },
  mounted() {
    if (navigator.geolocation) {
      setTimeout(() => {
        navigator.geolocation.getCurrentPosition(
          this.zoomToLocation,
          this.showError
        );
      }, 3000);
    }
  },

  computed: {},
  validations() {
    return {
      form: {
        email: {
          required,
          email,
        },
        name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(255),
        },
        mappoints: {
          required,
        },
        consents: {
          required,
          mustBe2Length: function (value) {
            if (this.form.phone !== "" && this.form.consents.length < 2) {
              return false;
            } else {
              return true;
            }
          },
        },
      },
    };
  },

  methods: {
    onMapReady(mapObject) {
      this.map = mapObject;
      this.getUserLocation();
    },
    getUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.zoomToLocation,
          this.showError
        );
      }
    },
    zoomToLocation(position) {
      const { latitude, longitude } = position.coords;
      this.userLocation = [latitude, longitude]; // Optional: Save user location to show a marker
      if (this.userLocation != null) {
        this.map.flyTo([latitude, longitude], 12);
      }
      // Fly to the user's location with zoom
    },

    showError(error) {
      console.error("Geolocation error:", error);
      // Handle error (e.g., show a default location, display a message, etc.)
    },
    addMarker(event) {
      const newMarker = {
        id: this.nextMarkerId++,
        latLng: [event.latlng.lat, event.latlng.lng],
      };
      this.markers = [];
      this.markers.push(newMarker);
      this.form.mappoints = [
        { lat: newMarker.latLng[0], lng: newMarker.latLng[1] },
      ];
    },
    onClickElement: function (name) {
      window.trackFormClick(name);
    },
    onBlurPhone: function () {
      this.form.phone = this.form.phone
        .replace(/[^\d\+]/g, "")
        .replace(/(.{3})/g, "$1 ")
        .substr(0, 15);
    },
    onEnterPhone: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }

      this.form.phone = this.form.phone
        .replace(/\W/gi, "")
        .replace(/(.{3})/g, "$1 ")
        .substr(0, 13);
    },

    onSubmit(evt) {
      let onSubmitButton = document.getElementById("onSubmitButton");

      if (onSubmitButton) {
        onSubmitButton.setAttribute("disabled", true);
        setTimeout(() => {
          onSubmitButton.removeAttribute("disabled");
        }, 2000);
      }

      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "formSendError",
          formName: "Formularz",
          errorForm: "1",
        });

        this.validationScrollToError();
        return;
      }
      this.isLoading = !this.isLoading;
      let dataForForm = this.getDataForPayment();

      axios
        .post(
          "https://bogini2.greenpeace.pl/api/v1/lead-campaigns/nawloc/lead",
          dataForForm,
          {
            headers: { crossDomain: true },
          }
        )
        .then((response) => {
          window.location.href = "https://wspieram.greenpeace.pl/lp/nawloc";
        })
        .catch((error) => {
          console.log(
            "An error occurred while making the POST request:",
            error
          );
          this.$router.push("/error");
        });
    },

    getDataForPayment() {
      return {
        name: this.form.name,
        email: this.form.email,
        consents: this.form.consents.map(Number),
        phone: this.form.phone,
        context: {
          mappoints: this.form.mappoints,
        },
      };
    },

    validationScrollToError: function () {
      setTimeout(() => {
        if (document.body.clientWidth < 992) {
          let elementsInErrorsName =
            document.getElementsByClassName("text-danger-name");
          if (elementsInErrorsName && elementsInErrorsName.length > 0) {
            let toScrollInputName = document.getElementById("name");
            toScrollInputName.scrollIntoView();
          }
        }
        if (!this.$v.form.mappoints.required) {
          window.errorOnFormField("text", "Pole jest wymagane");
        }
        if (!this.$v.form.name.required) {
          window.errorOnFormField("name", "Pole jest wymagane");
        } else if (!this.$v.form.name.minLength) {
          window.errorOnFormField(
            "name",
            "Minimalna długość imienia to 3 znaki"
          );
        } else if (!this.$v.form.name.maxLength) {
          window.errorOnFormField(
            "name",
            "Zbyt długie imię. Maksymalna długość to 255 znaków"
          );
        }
        if (!this.$v.form.email.required) {
          window.errorOnFormField("email", "Pole jest wymagane");
        } else if (!this.$v.form.email.email) {
          window.errorOnFormField("email", "Wpisz poprawny email");
        }
        if (!this.$v.form.consents.required) {
          window.errorOnFormField("consents", "Ta zgoda jest niebędna");
        }
      }, 50);
    },
  },

  watch: {
    modalShow: {
      handler: function (val) {
        if (val) {
          setTimeout(() => {
            this.showMap = true;
          }, 2000);
        } else {
          this.showMap = false;
        }
      },
      deep: true,
    },
  },
};
</script>
